$(document).ready(function () {
  $(".product-selector_block").click(function () {
    $(this)
      .closest(".product-selector_outer")
      .find(".product-selector_block")
      .removeClass("active");
    $(this).addClass("active");
  });

  $(".pp_var_autoship").click(function () {
    const $box = $(this);
    const $content = $box.closest(".product_selector-content");
    $box.toggleClass("disabled");
    if ($box.hasClass("disabled")) {
      $content.find('.product-selector_outer[data="sub"]').removeClass("active_block");
      $content.find('.product-selector_outer[data="otp"]').addClass("active_block");
    } else {
      $content.find('.product-selector_outer[data="sub"]').addClass("active_block");
      $content.find('.product-selector_outer[data="otp"]').removeClass("active_block");
    }
  });

  $(".product-selector_atc").click(function () {
    var $btn = $(this).addClass("loading");
    setTimeout(function () {
      $btn.removeClass("loading");
    }, 1000);

    var mode = $(".product-selector_outer.active_block").attr("data");
    var currentId =
      mode == "sub"
        ? $(this).attr("data-sub-id")
        : $(this).attr("data-otp-id");
    var currentSellingPlan = $(this).attr("data-selling-plan");

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: {
            id: currentId,
            quantity: 1,
            selling_plan: currentSellingPlan,
          },
          dataType: "json",
          success: function () {
            window.location.href = "/checkout";
          },
          error: function () {
            alert("Error adding item to the cart.");
          },
        });
      },
      error: function () {
        alert("Error clearing the cart.");
      },
    });
  });

  $(".product-selector_atc_ka")
    .not(".product-selector_atc_bundle")
    .click(function () {
      var $btn = $(this).addClass("loading");
      setTimeout(function () {
        $btn.removeClass("loading");
      }, 1000);

      var $root = $(this).closest(".main_product-outer");
      var activeOuter = $root.find(".product-selector_outer.active_block");
      var mode = activeOuter.attr("data");
      var activeBlock = activeOuter.find(".product-selector_block.active");
      var currentId = activeBlock.attr("data-id");

      var data = {
        id: currentId,
        quantity: 1,
      };

      if (mode == "sub") {
        data.selling_plan = activeBlock.attr("data-selling-plan");
      }

      jQuery.ajax({
        type: "POST",
        url: "/cart/clear.js",
        dataType: "json",
        success: function () {
          jQuery.ajax({
            type: "POST",
            url: "/cart/add.js",
            data: data,
            dataType: "json",
            success: function () {
              window.location.href = "/checkout";
            },
            error: function () {
              alert("Error adding item to the cart.");
            },
          });
        },
        error: function () {
          alert("Error clearing the cart.");
        },
      });
    });

  $(".product-selector_atc_bundle").click(function () {
    const $btn = $(this).addClass("loading");
    setTimeout(function () {
      $btn.removeClass("loading");
    }, 1000);
    const $root = $btn.closest(".main_product-outer");
    const activeOuter = $root.find(".product-selector_outer.active_block");
    const mode = activeOuter.attr("data");
    let activeBlock = activeOuter.find(".product-selector_block.active");
    if (!activeBlock.length) {
      activeBlock = activeOuter.find(".product-selector_block").first();
    }
    const bid = activeBlock.attr("data-bid") || "";
    const bundleProp = activeBlock.attr("data-bundle-prop") || "Bundle";
    const items = [];

    activeBlock.find(".js-bundle-item").each(function () {
      const $item = $(this);
      const id = $item.attr("data-id");
      if (!id) return;

      const line = {
        id,
        quantity: 1,
        properties: {
          _bid: bid,
          Bundle: bundleProp,
        },
      };

      const sellingPlan = $item.attr("data-selling-plan");
      if (mode === "sub" && sellingPlan) {
        line.selling_plan = sellingPlan;
      }

      items.push(line);
    });

    if (!items.length) {
      $btn.removeClass("loading");
      alert("No bundle products selected.");
      return;
    }

    jQuery.ajax({
      type: "POST",
      url: "/cart/clear.js",
      dataType: "json",
      success: function () {
        jQuery.ajax({
          type: "POST",
          url: "/cart/add.js",
          data: JSON.stringify({ items }),
          contentType: "application/json",
          dataType: "json",
          success: function () {
            window.location.href = "/checkout";
          },
          error: function () {
            $btn.removeClass("loading");
            alert("Error adding bundle to the cart.");
          },
        });
      },
      error: function () {
        $btn.removeClass("loading");
        alert("Error clearing the cart.");
      },
    });
  });

  $(".mpb_sub-cell").click(function () {
    $(".mpb_sub-cell").removeClass("active");
    $(this).addClass("active");

    var index = $(this).attr("data-index");
    $(".mpb_once-atc").addClass("hided");
    $('.mpb_once-atc[data-index="' + index + '"]').removeClass("hided");

    $(".mpb_small-atc-footer").addClass("hided");
    $('.mpb_small-atc-footer[data-index="' + index + '"]').removeClass("hided");
  });

  $(".mpb_main-atc").click(function () {
    var newUrl = $(".mpb_sub-cell.active").attr("data-coc-url");

    window.location.href = newUrl;

    // $('.mpb_main-atc').find('h4').html('ADDING');

    // var currentId = $('.mpb_sub-cell.active').attr('data-id');
    // var sellingId = $('.mpb_sub-cell.active').attr('data-selling-plan');
    // var data = {
    //     id: currentId,
    //     quantity: 1,
    //     selling_plan: sellingId
    // };

    // jQuery.ajax({
    //     type: "POST",
    //     url: "/cart/add.js",
    //     data: data,
    //     dataType: "json",
    //     success: function() {
    //       $('.mpb_main-atc').find('h4').html('ADD TO CART');
    //     },
    //     error: function() {
    //         alert('Error adding item to the cart.');
    //         $('.mpb_main-atc').find('h4').html('ADD TO CART');
    //     }
    // });
  });

  $(".mpb_once-atc").click(function () {
    var newUrl = $(this).attr("data-coc-url");

    window.location.href = newUrl;

    // var currentId = $(this).attr('data-id');

    // var data = {
    //     id: currentId,
    //     quantity: 1,
    // };

    // jQuery.ajax({
    //     type: "POST",
    //     url: "/cart/add.js",
    //     data: data,
    //     dataType: "json",
    //     success: function() {
    //     },
    //     error: function() {
    //         alert('Error adding item to the cart.');
    //     }
    // });
  });
});

// Coming back from checkout restores the page from the back/forward cache with the loader still on
window.addEventListener("pageshow", function (event) {
  if (event.persisted) {
    $(".product-selector_atc, .product-selector_atc_ka, .product-selector_atc_bundle").removeClass("loading");
  }
});
